/**
 * @generated SignedSource<<14fe1c848211c0c0afa5c9054d243c6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleasesInfoRemovable_offerFeaturedDeal$data = {
  readonly soundRecordings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "ReleasesInfoRemovable_offerFeaturedDeal";
};
export type ReleasesInfoRemovable_offerFeaturedDeal$key = {
  readonly " $data"?: ReleasesInfoRemovable_offerFeaturedDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReleasesInfoRemovable_offerFeaturedDeal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReleasesInfoRemovable_offerFeaturedDeal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SoundRecordingNodeConnection",
      "kind": "LinkedField",
      "name": "soundRecordings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SoundRecordingNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SoundRecordingNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OfferFeaturedDealInterface",
  "abstractKey": "__isOfferFeaturedDealInterface"
};

(node as any).hash = "35747838be34b5d73dce70f286a0f704";

export default node;
